export default "__VITE_ASSET__311d81fb__"